export const objectInitial = {};
export const arrayInitial = [];
export const stringInitial = "";
export const ProfileInitial = [];

export const authUserInitial = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  profileImage: "",
  userId: "",
  agencyId: "",
  agencyName: "",
  roleName: "",
  stateId: "",
  stateName: "",
  zip: "",
};
export const agencyInitial = {
  agencyId: "",
  agencyName: "",
  ttid: "",
  taxId: "",
  accountNumber: "",
  accountHolderName: "",
  bankAddress: "",
  ifscCode: "",
  agencyLogo: "",
  stateId: "",
  stateName: "",
  city: "",
  address: "",
  zip: "",
  phoneNumber: "",
  agencyEmail: "",
  agencyFax: "",
  agencyUrl: "",
};

export const dogInitials = [];
export const dogDetails = [];

export const IntialType = [
  { value: "text", type: "Text Box" },
  { value: "textarea", type: "Text Area" },
  { value: "radio", type: "Multiple Choice" },
  { value: "checkbox", type: "Checkboxes" },
  { value: "select", type: "Drop Down" },
  { value: "date", type: "Date" },
  { value: "time", type: "Time" },
  { value: "number", type: "Number" },
];

export const special = [
  { label: "Pet name", value: "PET_VALUE" },
  { label: "User Name", value: "USER_NAME" },
  { label: "Pet Breed", value: "PET_BREED" },
  { label: "Pet color", value: "PET_COLOR" },
  { label: "Customer state", value: "CUSTOMER_STATE" },
];
export const formInitial = {
  formValues: [],
};

export const documentIntial = [
  {
    uniqueId: Date.now(),
    licenseRequiredDocId: 0,
    documentName: "",
    documentDescription: "",
    isMandatory: false,
    validationType: "string",
    validations: [
      {
        type: "required",
        params: ["Required"],
      },
    ],
  },
];

export const CategoryInitial = [];

export const EndUserFormInitial = {
  planName: "",
  planDescription: "",
  licenseRequiredDocDetails: [],
  categoryDetails: [],
  categoryId: [],
  planDuration: "",
  form: {
    selectedCategory: 0,
    selectedTab: 0,
    answers: {},
  },
  error: false,
};

export const DogPlanDetails = {
  categoryDetails: null,
  licenseRequiredDocDetails: null,
};

export const FieldsInitial = {
  currentStep: 1,
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  gender: "",
  dateOfBirth: "",
  phoneNumber: "",
  profileImage: "",
  stateId: "",
  city: "",
  address: "",
  zip: "",
  agencyUrl: "",
  dogName: "",
  breed: "",
  color: "",
  DOB: "",
  sex: "",
  dogImageUrl: "",
  dogDescription: "",
};
